import api from '../../utils/helpers/api'
import type {
  AktivitasPenugasan,
  AktivitasPenugasanParams,
  AktivitasPenugasanFormData,
  GroupedAktivitas,
} from '../../types/pana'

type ResponType = {
  data: any
  meta: object
}

const aktivitasPenugasan = {
  /**
   * Get list aktivitas penugasan with pagination
   */
  getList: async (params?: AktivitasPenugasanParams): Promise<ResponType> => {
    return (await api.get('/pana-aktivitas-penugasan', {params})) as Promise<ResponType>
  },

  /**
   * Get all aktivitas penugasan without pagination
   */
  getAll: async (): Promise<ResponType> => {
    return (await api.get('/pana-aktivitas-penugasan/get-all')) as Promise<ResponType>
  },

  /**
   * Get aktivitas penugasan grouped by minggu
   */
  getGroupedByMinggu: async (): Promise<ResponType> => {
    return (await api.get('/pana-aktivitas-penugasan/grouped-by-minggu')) as Promise<ResponType>
  },

  /**
   * Get aktivitas penugasan by minggu ke
   */
  getByMinggu: async (minggu: number): Promise<ResponType> => {
    return (await api.get(`/pana-aktivitas-penugasan/by-minggu/${minggu}`)) as Promise<ResponType>
  },

  /**
   * Get detail aktivitas penugasan by ID
   */
  show: async (id: number): Promise<ResponType> => {
    return (await api.get(`/pana-aktivitas-penugasan/${id}`)) as Promise<ResponType>
  },

  /**
   * Create new aktivitas penugasan
   */
  create: async (data: AktivitasPenugasanFormData): Promise<ResponType> => {
    return (await api.post('/pana-aktivitas-penugasan', data)) as Promise<ResponType>
  },

  /**
   * Update aktivitas penugasan
   */
  update: async (id: number, data: Partial<AktivitasPenugasanFormData>): Promise<ResponType> => {
    return (await api.put(`/pana-aktivitas-penugasan/${id}`, data)) as Promise<ResponType>
  },

  /**
   * Delete aktivitas penugasan
   */
  delete: async (id: number): Promise<ResponType> => {
    return (await api.delete(`/pana-aktivitas-penugasan/${id}`)) as Promise<ResponType>
  },

  /**
   * Toggle status aktivitas penugasan (active/inactive)
   */
  toggleStatus: async (id: number): Promise<ResponType> => {
    return (await api.post(`/pana-aktivitas-penugasan/${id}/toggle-status`)) as Promise<
      ResponType
    >
  },
}

export default aktivitasPenugasan
